import React from "react";
import { useQuery } from "react-query";
import { getReportsTab } from "../../../../../actions/Utilities/CustomReport";

const useGetReportsTab = () => {
  return useQuery("GetReportsTab", getReportsTab, {
    refetchOnWindowFocus: false,
  });
};

export default useGetReportsTab;
